
define(
	'Code25.Phone'
	, [
		"underscore", "jQuery", "Utils", "Profile.Model", "Profile.Model", "Address.Model", "Configuration"
	]
	, function (
		_, jQuery, Utils, ProfileModel, AddressModel, Configuration
	) {
		'use strict';

		return {
			mount: function (container) {
return;

				// function validatePhone(phone) {

				// 	phone = (phone || "").toString();
				// 	if (phone) {
				// 		if (phone.length != 11) {
				// 			return Utils.translate('Phone number should be 11 numbers with no additional spaces or characters.');
				// 		}
				// 		var c;
				// 		for (var i = 0; i < phone.length; i++) {
				// 			c = phone.charAt(i);
				// 			if (c < '0' || c > '9') {
				// 				return Utils.translate('Phone number should be 11 numbers with no additional spaces or characters.');
				// 			}
				// 		}
				// 	}
				// 	return ""
				// }

				// function requirePhone(phone) {
				// 	if (value) {
				// 		return validatePhone(phone);
				// 	}
				// 	else if (
				// 		Configuration.get('addresses') &&
				// 		Configuration.get('addresses.isPhoneMandatory')
				// 	) {
				// 		return 'Phone Number is required';
				// 	}
				// }
				// ProfileModel.prototype.validation.phone.fn = validatePhone;

				// AddressModel.prototype.validation.phone.fn = requirePhone;

				// Utils.formatPhone = function (phone, format) {

				// 	phone = (phone || "").toString();
				// 	var c, newPhone = "";
				// 	for (var i = 0; i < phone.length; i++) {
				// 		c = phone.charAt(i);
				// 		if (c >= '0' && c <= '9') {
				// 			newPhone += c;
				// 		}
				// 	}

				// 	return newPhone;
				// }
				// Utils.validatePhone = validatePhone;

				// if (SC.ENVIRONMENT.SCTouchpoint == "myaccount" || SC.ENVIRONMENT.SCTouchpoint == "checkout") {
				// 	var AddressEditFieldsView = require("Address.Edit.Fields.View");
				// 	AddressEditFieldsView.prototype.formatPhone = function (e) {
				// 		var $target = jQuery(e.target);
				// 		$target.val((Utils.formatPhone($target.val())));
				// 	};
				// }


			}
		};

	});
